import { useState } from "react";
import { TFilters } from "../../../../../components/TableDataGridV2/types";
import { Box, Button, Container, Divider, Grid, TextField } from "@mui/material";
import SelectPublico from "../../../../../components/SelectsSimpleApiQuery/SelectPublico";
import DateComIntervalo from "../../../../../components/DateComIntervalo";
import { permitirApenasNumeros } from "../../../../../helpers/masks";

export default function PreFiltros({
    filtros,
    isListarTodas = false,
    onSubmitFilters
}:PreFiltrosTitulosPagarProps) {

    const [internFilters, setInternFilters] = useState(filtros)

    const filtrarObj = (obj: TFilters) => {
        const novoObjeto: TFilters = { ...obj };

        Object.keys(novoObjeto).forEach((key) => {
            if (key.startsWith('publico_dado')) {
                novoObjeto.tipo_publico_contem = [novoObjeto[key].tipo_publico];
                novoObjeto.codigo_publico_contem = [novoObjeto[key].codigo_publico];
                delete novoObjeto[key];
            }
        });

        return novoObjeto;
    };

    const handleInsertFiltros = (prop: string, value: any) => {
        setInternFilters(prevState => ({ ...prevState, [prop]: value }))
    }

    const handleSubmit = () => {
        const formatValue = filtrarObj(internFilters)
        onSubmitFilters(formatValue)
    }

  return (
    <Container maxWidth="md">
            <Grid container spacing={2} sx={{ py: !isListarTodas? 2 : 0 }}>
                <Grid size={{xs: 12, md: 6}}>
                    <SelectPublico
                        value={internFilters.publico_dado}
                        onChange={(valor) => handleInsertFiltros("publico_dado", valor)}
                    />
                </Grid>

                <Grid size={{xs: 12, md: 6}}>
                    <DateComIntervalo
                        data={{
                            inicial: internFilters.data_vencimento_inicio,
                            final: internFilters.data_vencimento_fim
                        }}
                        onChangeData={(data) => {
                            handleInsertFiltros("data_vencimento_inicio", data.inicial)
                            handleInsertFiltros("data_vencimento_fim", data.final)
                        }}
                        datePickerView={['year', 'month', 'day']}
                        formatString="DD/MM/YYYY"
                        labelInput="Data de vencimento"
                    />
                </Grid>
            </Grid>

            {!isListarTodas &&  <Divider />}

            <Grid container spacing={2} sx={{ py: 2 }}>
                <Grid size={{xs: 12, md: 6}}>
                    <TextField
                        label="Nº do documento"
                        variant="outlined"
                        fullWidth
                        value={internFilters.numero_documento_pesquisar}
                        onChange={(e) => handleInsertFiltros("numero_documento_pesquisar", permitirApenasNumeros(e.target.value))}
                    />
                </Grid>

                <Grid size={{xs: 12, md: 6}}>
                    <DateComIntervalo
                        data={{
                            inicial: internFilters.data_emissao_inicio,
                            final: internFilters.data_emissao_fim
                        }}
                        onChangeData={(data) => {
                            handleInsertFiltros("data_emissao_inicio", data.inicial)
                            handleInsertFiltros("data_emissao_fim", data.final)
                        }}
                        datePickerView={['year', 'month', 'day']}
                        formatString="DD/MM/YYYY"
                        labelInput="Data de emissão"
                    />
                </Grid>

                <Grid size={{xs: 12, md: 6}}>
                    <TextField
                        label="Valor"
                        variant="outlined"
                        fullWidth
                        type="number"
                        value={internFilters.valor_receber_maior_igual}
                        onChange={(e) => {
                            handleInsertFiltros("valor_pagar_maior_igual", e.target.value)
                            handleInsertFiltros("valor_pagar_menor_igual", e.target.value)
                        }}
                    />
                </Grid>

                <Grid size={{xs: 12, md: 6}}>
                    <TextField
                        label="Saldo"
                        variant="outlined"
                        fullWidth
                        type="number"
                        value={internFilters.saldo_principal_maior_igual}
                        onChange={(e) => {
                            handleInsertFiltros("saldo_principal_maior_igual", e.target.value)
                            handleInsertFiltros("saldo_principal_menor_igual", e.target.value)
                        }}
                    />
                </Grid>

            </Grid>

            <Box>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                >
                    Pesquisar
                </Button>
            </Box>
        </Container>
  )
}

interface PreFiltrosTitulosPagarProps {
    filtros: TFilters,
    isListarTodas?: boolean,
    onSubmitFilters: (args: TFilters) => void
}
